import * as Sentry from '@sentry/tanstackstart-react';
import { useEffect } from 'react';

export function NotFound() {
  useEffect(() => {
    Sentry.captureEvent({
      message: 'Page non trouvée',
      level: 'warning',
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <p className="text-2xl font-bold">
        Il semblerait qu'il n'y ait rien à afficher ici 🙈...
      </p>
    </div>
  );
}
